export default {
  tipoDoc: 'Type de document',
  nroDoc: 'Numéro de document',
  nombres: 'Noms',
  primerAp: 'Prénom',
  segundoAp: 'Deuxième nom de famille',
  telefono: 'Numéro de téléphone mobilel',
  email: 'Courriel electrónico',
  nacionalidad: 'Nationalité',
  nro_legalizacion: 'Nombre d’Apostille',
  cod_seguridad: 'Code de sécurité',
  codigo: 'Code de suivi',
  day: 'Journée',
  month: 'Mois',
  year: 'Année',
  nombre_solicitante: 'Nom du demandeur',
  precio: 'Prix',
  estado: 'ESTADO (fr)',
  fecha_expedicion: 'Date d’émission de l’Apostille',
  fecha_nacimiento: 'Date de naissance',
  docFactura: 'Número de documento',
  tipoFactura: 'Tipo de documento',
  nombreFactura: 'Nombre completo',
  fecha_solicitud: 'Fecha de solicitud (fr)',
  det_tramite: 'Detalles de su trámite (Frances)',
  info_sol: 'DATOS DEL TITULAR DEL DOCUMENTO (fr)',
  info_doc: 'DOCUMENTO(S) (fr)',
  info_doc_adjuntar: 'ADJUNTAR ARCHIVO(S) (fr)',
  info_pago: 'DATOS DE PAGO (fr)',
  info_finalizado: 'FINALIZADO (fr)',
  info_cont: 'Ingrese sus datos personales y de contacto para recibir notificaciones sobre el estado de su trámite (frances)',
  info_email: 'Por favor verifique que la información obtenida que sea correcta y corresponda al titular autenticado por la plataforma de Ciudadania Digital. Tome en cuenta que para poder enviar el documento a la apostilla, después de ser legalizado o certificado se enviara a la dirección de correo electrónico que muestra el formulario.',
  info_agregar: 'Agregue el/los documento(s) que necesita legalizarr (fr)',
  alert_doc: 'Todavía no tiene ningún documento agregado (fr)',
  mis_doc: 'Mis documentos (fr)',
  desc_doc: 'Descripción del/de los documento(s) (fr)',
  select_doc: 'Seleccione un documento para legalizar (fr)',
  select_gestion: 'Año de emisión del documento (fr)',
  doc: 'Documento (fr)',
  docs: 'Documentos (fr)',
  titulo_factura: 'Ingrese sus datos para la factura (fr)',
  datos_pago: 'Verifique los datos de pago. La factura solo cubre el pago de la(s) legalizacion(es) (fr)',
  titular_factura: 'Señor(es) (fr)',
  costo_doc: 'Costo de documento(s) (fr)',
  costo_legalizacion: 'Costo legalizacion(es) (fr)',
  confirmacion_solicitud: '¿Está seguro que quiere realizar su solicitud con estos datos? (fr)',
  confirmar: 'Confirmar (fr)',
  aceptar: 'Aceptar (fr)',
  cancelar: 'Cancelar (fr)',
  fin_solicitud: '¡Su solicitud se ha realizado correctamente! (fr)',
  cod_seguimiento: 'Su código de seguimiento es (fr):',
  guardar_codigo: 'Guarde el código (fr)',
  seguimiento_codigo: ' de seguimiento para ver el estado de su solicitud ingresando  (fr)',
  aqui: 'aquí (fr)',
  ingrese_codigo_seguimiento: 'Ingrese el código de seguimiento para ver el estado de su trámite. (fr)',
  verificar_documento: 'Ingresa la información requerida para verificar que el documento se encuentre legalizado/certificado. (fr)',
  datos_del_solicitante: 'Datos del solicitante (fr)',
  pago_entidad: 'Pagado en la entidad (fr)',
  pago_minedu: 'Pagado en MINEDU (fr)',
  motivo: 'Destino del trámite (fr)',
  adjunto: 'Por favor, adjunte el documento que desea certificar (fr)',
  adjuntar: 'Arrastre su archivo aquí o haga click para seleccionarlo (fr)',
  cargando: 'Guardando ... (fr)',
  cargado: 'Archivo cargado (fr)',
  nota: 'NOTA: (fr)',
  nota_contenido: 'Por favor adjunte el documento que desea que sea procesado para los siguientes trámites, su solicitud NO será procesada si los adjuntos no fueron completados',
  nota_contenido_2: 'Es necesario que usted se haga presente en las oficinas del Ministerio de Educación, portando los documentos originales correspondientes a los adjuntos. Caso contrario, el trámite no podrá tener continuidad.',
  adjunto_ok: 'Archivo cargado correctamente (fr)',
  gestion: 'Gestión (fr)',
  tramitador_nroDoc: 'Numéro de document'
};



// WEBPACK FOOTER //
// ./src/lang/fr/fields.js